import { createBrowserRouter, Navigate } from 'react-router';

/**
 * Components
 */
import Layout from '@/layout';

/**
 * Constants
 */
const modules: Record<string, () => Promise<any>> = {
    focus: () => import('@/pages/focus'),
    matrix: () => import('@/pages/matrix'),
    tasks: () => import('@/pages/tasks'),
};

const lazy = (name: string) => {
    return () => modules[name]().then((module) => ({ ...module, Component: module.default }));
};

export const router = createBrowserRouter([
    {
        children: [
            {
                element: <Navigate to="/tasks" replace />,
                path: '/',
            },
            // 任务
            {
                path: '/tasks',
                lazy: lazy('tasks'),
            },
            // 四象限
            {
                path: '/matrix',
                lazy: lazy('matrix'),
            },
            // 专注
            {
                path: '/focus',
                lazy: lazy('focus'),
            },
            {
                path: '/about',
                lazy: lazy('about'),
            },
        ],
        element: <Layout />,
    },
]);
